import { NgFor } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { EmrButtonComponent } from 'emr-ng-shared';

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.css'],
  standalone: true,
  imports: [NgFor, EmrButtonComponent, ]
})
export class ContactListComponent implements OnInit {

  @Input() public contactList: any[] = [];

  constructor() { }

  ngOnInit() {
  }

  DeleteContact(index) {
    this.contactList.splice(index, 1);
  }

}
